import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody } from 'reactstrap';
import { t } from '../common/Translate';

const ModalPreEmption = ({ isOpen, toggle, validatePreEmption, closePreEmption }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className="modal" size="md">
      <ModalBody className="pb-0">
        <div className="modal-guaranteed text-center">{t('confirmCarPreEmption')}</div>
        <div className="mt-5 text-center">
          <button type="button" className="btn btn-3 mr-3" onClick={closePreEmption}>
            {t('close')}
          </button>
          <button type="button" className="btn btn-1" onClick={validatePreEmption}>
            {t('validate')}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

ModalPreEmption.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  closePreEmption: PropTypes.string.isRequired,
  validatePreEmption: PropTypes.string.isRequired,
};
export default ModalPreEmption;
